// 获取可被缓存的图形节点  ->  组合和表格（子元素个数大于10）
import { IComponentWrapper } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/component-wrapper.interface';
import { Container } from '@tencent/alloy-renderer';
import { RenderPostionType } from '@src/js/constant';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ElementsAnalyze } from '@src/slide/domain/ui-model/element-modeles/elements-analysis';

// 组合和表格是否加入缓存的限制（子节点大于多少）
export const MAKE_CACHE_FLOOR_LIMIT = 100;

/**
 * 获取可被缓存的图形节点  ->  组合和表格（子元素个数大于10）
 * @param component
 */
const getCanCacheComponent = (component: IComponentWrapper): Container | undefined => {
    const { model, region } = component?.factoryOptions || {};
    // 只对编辑区的有效
    if (region !== RenderPostionType.CANVAS) {
        return;
    }
    // 因为缓存会消耗内存，并且对子节点多的图形效果更好，所以只对组合和表格（子元素个数大于10）做处理
    if (model?.type && ![UIModelType.GROUP, UIModelType.TABLE].includes(model?.type)) {
        return;
    }
    if (ElementsAnalyze.includeBaseElementCount(model) < MAKE_CACHE_FLOOR_LIMIT) {
        return;
    }
    return component.wrapperInstance;
};

/**
 * 给节点添加缓存
 * @param component
 */
export const componentMakeCache = (component: IComponentWrapper): void => {
    const canCacheComponent = getCanCacheComponent(component);
    setTimeout(() => {
        if (canCacheComponent?.cache?.isEmpty) {
            canCacheComponent.makeCache(false, true);
        }
    }, 0);
};

/**
 * 清除节点的缓存
 * @param component
 */
export const componentClearCache = (component: IComponentWrapper): void => {
    const canCacheComponent = getCanCacheComponent(component);
    if (canCacheComponent) {
        canCacheComponent.clearCache();
    }
};
